import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
    ShActionGroupComponent,
    ShActionItemComponent,
    ShDynamicDialogService,
    ShFormMultiSelectModule,
    ShLabelComponent,
    ShNotificationComponent,
    ShPageHeaderComponent,
    ShPaginationComponent,
    ShProgressLabelComponent
} from '@stylehaven/components';
import { DigihavenElementsModule } from '../elements/elements.module';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe/readable-date-pipe.module';
import { BatchesRoutingModule } from './batches-routing.module';
import { BatchErrorDialogComponent } from './containers/batch-error-dialog/batch-error-dialog.component';
import { BatchesOverviewContainerComponent } from './containers/batches-overview-container/batches-overview-container.component';
import { BatchesSandboxService } from './sandbox/batches-sandbox.service';

@NgModule({
    declarations: [BatchesOverviewContainerComponent, BatchErrorDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BatchesRoutingModule,
        TranslateModule,
        ShPageHeaderComponent,
        ShFormMultiSelectModule,
        ShNotificationComponent,
        ShActionItemComponent,
        ShProgressLabelComponent,
        ShActionGroupComponent,
        DigihavenElementsModule,
        ReadableDatePipeModule,
        ShLabelComponent,
        ShPaginationComponent
    ],
    providers: [BatchesSandboxService, ShDynamicDialogService],
    exports: [BatchesOverviewContainerComponent]
})
export class BatchesModule {}

export { BatchesOverviewContainerComponent } from './containers/batches-overview-container/batches-overview-container.component';
